module.exports = __webpack_public_path__ + "img/7fa1ace.png";